const IE_COUNTY_MAPPINGS = {
  CW: 'Carlow',
  CN: 'Cavan',
  CE: 'Clare',
  CO: 'Cork',
  DL: 'Donegal',
  D: 'Dublin',
  G: 'Galway',
  KY: 'Kerry',
  KE: 'Kildare',
  KK: 'Kilkenny',
  LS: 'Laois',
  LM: 'Leitrim',
  LK: 'Limerick',
  LD: 'Longford',
  LH: 'Louth',
  MO: 'Mayo',
  MH: 'Meath',
  MN: 'Monaghan',
  OY: 'Offaly',
  RN: 'Roscommon',
  SO: 'Sligo',
  TA: 'Tipperary',
  WD: 'Waterford',
  WH: 'Westmeath',
  WX: 'Wexford',
  WW: 'Wicklow',
};

const AU_STATE_MAPPINGS = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia',
};

const US_STATE_MAPPINGS = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

// this maps to a translation key because we possibly need French
const CA_PROVINCE_MAPPINGS = {
  AB: 'ca.province.alberta',
  BC: 'ca.province.british_columbia',
  MB: 'ca.province.manitoba',
  NB: 'ca.province.new_brunswick',
  NL: 'ca.province.newfoundland_and_labrador',
  NT: 'ca.province.northwest_territories',
  NS: 'ca.province.nova_scotia',
  NU: 'ca.province.nunavut',
  ON: 'ca.province.ontario',
  PE: 'ca.province.prince_edward_island',
  QC: 'ca.province.quebec',
  SK: 'ca.province.saskatchewan',
  YT: 'ca.province.yukon',
};

//  I18n.with_locale(:ja) { Square::Countries.find_country('JP').states }.freeze
const JP_PREFECTURE_MAPPINGS = {
  北海道: '01',
  青森県: '02',
  岩手県: '03',
  宮城県: '04',
  秋田県: '05',
  山形県: '06',
  福島県: '07',
  茨城県: '08',
  栃木県: '09',
  群馬県: '10',
  埼玉県: '11',
  千葉県: '12',
  東京都: '13',
  神奈川県: '14',
  新潟県: '15',
  富山県: '16',
  石川県: '17',
  福井県: '18',
  山梨県: '19',
  長野県: '20',
  岐阜県: '21',
  静岡県: '22',
  愛知県: '23',
  三重県: '24',
  滋賀県: '25',
  京都府: '26',
  大阪府: '27',
  兵庫県: '28',
  奈良県: '29',
  和歌山県: '30',
  鳥取県: '31',
  島根県: '32',
  岡山県: '33',
  広島県: '34',
  山口県: '35',
  徳島県: '36',
  香川県: '37',
  愛媛県: '38',
  高知県: '39',
  福岡県: '40',
  佐賀県: '41',
  長崎県: '42',
  熊本県: '43',
  大分県: '44',
  宮崎県: '45',
  鹿児島県: '46',
  沖縄県: '47',
};

const ADJUSTMENT_TYPE_MAPPINGS = {
  line_item: 'checkout.receipt.label.productDiscount',
  order: 'checkout.receipt.label.cartDiscount',
  shipment: 'checkout.receipt.label.freeShipping',
};

const PAYMENT_RESPONSE_ERROR_STATUS_MAPPINGS = Object.freeze({
  PAYMENT_ALREADY_CHARGED: 'Payment already charged',
  PAYMENT_REQUIRED: 'Payment required',
  PAYMENT_FAILED: 'Payment failed',
  CARD_DETAILS_REQUIRED: 'Card details required',
  ISSUER_INSTALLMENT_ERROR: 'Issuer installment error',
  CUSTOMER_CREATION_FAILED: 'Customer creation failed',
  CARD_CREATION_FAILED: 'Card creation failed',
  INSTRUMENT_VERIFICATION_FAILED: 'Instrument verification failed',
  CARD_MIGRATION_FAILED: 'Card migration failed',
});

export {
  IE_COUNTY_MAPPINGS,
  US_STATE_MAPPINGS,
  AU_STATE_MAPPINGS,
  CA_PROVINCE_MAPPINGS,
  JP_PREFECTURE_MAPPINGS,
  ADJUSTMENT_TYPE_MAPPINGS,
  PAYMENT_RESPONSE_ERROR_STATUS_MAPPINGS,
};
